import { INhomLopSinhVienActionTypes } from "../../action-types/category/INhomLopSinhVienActions";
import { INhomLopSinhVienReducer } from "../../reducer-model/category/INhomLopSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: INhomLopSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    nhomLopSinhViens: [],
    selectedIds: [],
    showAddModal: false,
    scanPreviewList: [],
    scanPreviewIds: [],
    isScanPreviewLoading: false,
};
export const nhomLopSinhVienReducer = (
    state: INhomLopSinhVienReducer = iniState,
    action: INhomLopSinhVienActionTypes
): INhomLopSinhVienReducer => {
    switch (action.type) {
        case "NHOM_LOP_SINH_VIEN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                selectedIds: []
            };
        case "NHOM_LOP_SINH_VIEN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                nhomLopSinhViens: action.payload,
            };
        case "NHOM_LOP_SINH_VIEN_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "NHOM_LOP_SINH_VIEN_CHANGE_FOCUSED_DATA":
            return {
                ...state,
                focusedData: action.payload,
                selectedIds: []
            };
        case "NHOM_LOP_SINH_VIEN_CHANGE_SELECTED_IDS":
            return {
                ...state,
                selectedIds: action.payload
            };
        case "NHOM_LOP_SINH_VIEN_SHOW_ADD_MODAL":
            return {
                ...state,
                showAddModal: action.payload
            };
        case "NHOM_LOP_SINH_VIEN_CLOSE_ADD_MODAL":
            return {
                ...state,
                showAddModal: false
            };
        case "NHOM_LOP_SINH_VIEN_ADD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "NHOM_LOP_SINH_VIEN_ADD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                showAddModal: false,
            };
        case "NHOM_LOP_SINH_VIEN_ADD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "NHOM_LOP_SINH_VIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "NHOM_LOP_SINH_VIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            };
        case "NHOM_LOP_SINH_VIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "NHOM_LOP_SINH_VIEN_ADDS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "NHOM_LOP_SINH_VIEN_ADDS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                showAddModal: false,
            };
        case "NHOM_LOP_SINH_VIEN_ADDS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_PREVIEW_START":
            return {
                ...state,
                scanPreviewMode: "add",
                scanPreviewList: [],
                scanPreviewIds: action.payload.ids,
                isScanPreviewLoading: true
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_PREVIEW_SUCCESS":
            return {
                ...state,
                scanPreviewList: action.payload,
                isScanPreviewLoading: false
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_PREVIEW_ERROR":
            return {
                ...state,
                scanPreviewMode: undefined,
                isScanPreviewLoading: false
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_PREVIEW_START":
            return {
                ...state,
                scanPreviewMode: "remove",
                scanPreviewList: [],
                scanPreviewIds: action.payload.ids,
                isScanPreviewLoading: true
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_PREVIEW_SUCCESS":
            return {
                ...state,
                scanPreviewList: action.payload,
                isScanPreviewLoading: false
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_PREVIEW_ERROR":
            return {
                ...state,
                scanPreviewMode: undefined,
                isScanPreviewLoading: false
            };
        case "NHOM_LOP_SINH_VIEN_CLOSE_SCAN_PREVIEW_MODAL":
            return {
                ...state,
                scanPreviewMode: undefined,
                scanPreviewList: [],
                scanPreviewIds: [],
                isScanPreviewLoading: false
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                scanPreviewMode: undefined,
                scanPreviewList: [],
                scanPreviewIds: []
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_ADD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                selectedIds: [],
                scanPreviewMode: undefined,
                scanPreviewList: [],
                scanPreviewIds: []
            };
        case "NHOM_LOP_SINH_VIEN_SCAN_REMOVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};
